import { render, staticRenderFns } from "./ConsentList.vue?vue&type=template&id=53b234b0"
import script from "./ConsentList.vue?vue&type=script&lang=js"
export * from "./ConsentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports